export function getShareURL(teamSlug: string, inviteID: string) {
  const params = new URLSearchParams([
    ['utm_source', 'instruqt'],
    ['utm_medium', 'share_button'],
    ['utm_campaign', 'referral'],
  ]);

  return `${window.location.origin}/${teamSlug}/invite/${inviteID}?${params.toString()}`;
}
